package br.com.texeratx.boardgametimeapp.ui.utils

import kotlin.js.Date

actual fun todayApiDate(): String {
    val d = Date()
    val year = d.getFullYear().toInt()
    val month = (d.getMonth().toInt() + 1).toString().padStart(2, '0')
    val day = d.getDate().toInt().toString().padStart(2, '0')
    return "$year-$month-$day"
}

actual fun nowApiDateTime(): String {
    val d = Date()
    val year = d.getFullYear().toInt()
    val month = (d.getMonth().toInt() + 1).toString().padStart(2, '0')
    val day = d.getDate().toInt().toString().padStart(2, '0')
    val hour = d.getHours().toInt().toString().padStart(2, '0')
    val min = d.getMinutes().toInt().toString().padStart(2, '0')
    return "$year-$month-${day}T$hour:$min"
}

actual fun epochMillisToApiDateTime(epochMillis: Long): String {
    val d = Date(epochMillis.toDouble())
    val year = d.getFullYear().toInt()
    val month = (d.getMonth().toInt() + 1).toString().padStart(2, '0')
    val day = d.getDate().toInt().toString().padStart(2, '0')
    val hour = d.getHours().toInt().toString().padStart(2, '0')
    val min = d.getMinutes().toInt().toString().padStart(2, '0')
    return "$year-$month-${day}T$hour:$min"
}
